import { render, staticRenderFns } from "./AutocompleteCustom.vue?vue&type=template&id=45e1305a&"
import script from "./AutocompleteCustom.vue?vue&type=script&lang=js&"
export * from "./AutocompleteCustom.vue?vue&type=script&lang=js&"
import style0 from "./AutocompleteCustom.vue?vue&type=style&index=0&id=45e1305a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports